
import HasDataTable from '../hoc/HasDataTable';
import MxDataTable from '@/components/global/MxDataTable.vue';
import projectService from '@/services/ProjectService';
import ProjectStatusChip from './ProjectStatusChip.vue';
import UserGroupSelector from '@/components/users/UserGroupSelector.vue';
import { AnyObject } from '@/types/generic.types';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { IPaginatedRequest, IPaginatedResult } from '@/types/services.types';
import { IProject, ProjectStatus } from '@/types/resource.types';
import { paths } from '@/router/route-paths';
import { Sync } from 'vuex-pathify';

@Component({
    name: 'ProjectsTable',
    components: {
        MxDataTable,
        ProjectStatusChip,
        UserGroupSelector,
    }
})
export default class ProjectsTable extends HasDataTable {

    /* Props
    ============================================*/

    @Prop({type: Object, required: false})
    readonly initialRequest: IPaginatedRequest;

    /* Data
    ============================================*/

    @Sync('results/projectsListPath')
    projectsListPath: string | null;

    loadingProjects: boolean = false;
    result: IPaginatedResult<IProject> | null = null;
    userProjectsOnly: boolean = this.$route.query.useronly !== 'false';
    queryParameters: AnyObject = {
        useronly: this.$route.query.useronly !== 'false'
    }

    /* Computed
    ============================================*/

    get headers() {
        return projectTableHeaders;
    }

    /* Methods
    ============================================*/

    goToProject(project: IProject) {
        this.projectsListPath = window.location.pathname + window.location.search;
        if(project.status === ProjectStatus.Draft) {
            this.$router.push(paths.PROJECT_DRAFT(project.id));
        }
        else {
            this.$router.push(paths.PROJECT_SUMMARY(project.id));
        }
    }

    async searchProjects(req: IPaginatedRequest) {
        try {
            this.loadingProjects = true;
            let result = this.userProjectsOnly
                ? await projectService.getForUser(this.$user.id, req)
                : await projectService.getList(req);
            this.result = result;
        } catch(e) {
            this.$logger.logError(e);
            this.$toast.error('There was a problem loading the project list. Please try again.');
        } finally {
            this.loadingProjects = false;
        }
    }

    setUserQueryParameter(useronly: boolean) {
        this.queryParameters = { useronly };
    }

    @Watch('$route')
    onRouteChanged() {
        const useronly = this.$route.query.useronly !== 'false';
        this.userProjectsOnly = useronly;
        this.queryParameters = { useronly };
    }

    @Watch('userProjectsOnly')
    onUserProjectsOnlyChanged() {
        this.reloadTable();
    }

}

export const projectTableHeaders: DataTableHeader<IProject>[] = [
    {
        text: 'Created',
        value: 'created'
    },
    {
        text: 'Submitted',
        value: 'submitted'
    },
    {
        text: 'Project ID',
        value: 'id'
    },
    {
        text: 'Examiner',
        value: 'examinerName'
    },
    {
        text: 'Case ID',
        value: 'caseId'
    },
    {
        text: 'Lab ID',
        value: 'labId'
    },
    {
        align: 'end',
        text: 'Status',
        value: 'status'
    }
];

